/*
 * Google Analytics Tracking
 */
const GA_TRACKING_ID = 'G-TJH9KFSYT5'

class GoogleAnalytics {
  trackGA (page, location, profile) {
    window.gtag('config', GA_TRACKING_ID, {
        page_title: page,
        page_path: location.pathname,
        user_name: profile && profile.name,
        user_email: profile && profile.email,
        user_group: profile && profile.groups
    })
  }
}

const instance = new GoogleAnalytics()

export default instance
